import styled from "styled-components";

/**
 * Container principal para a lista de vendedores.
 */
export const SellersListContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  display: flex;
`;

/**
 * Estilização de cada item da lista de vendedores.
 */
export const SellerItem = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.darkGreen};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding-left: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  display: grid;

  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    /* border: 1px solid ${({ theme }) => theme.colors.black}; */
  }
`;

/**
 * Container principal para a lista de vendedores.
 */
export const SallerContent = styled.div`
  padding-right: ${({ theme }) => theme.spacing(2)};
  justify-content: space-between;
  align-items: center;
  display: flex;
`;

/**
 * Logo do vendedor.
 */
export const SellerLogo = styled.img`
  /* height: 40px; */
  width: 80px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 40px;
  }
`;

/**
 * Botão para ação de redirecionamento.
 */
export const SellerAction = styled.button`
  padding: ${({ theme }) => theme.spacing(1.75)}
    ${({ theme }) => theme.spacing(3)};
  background-color: ${({ theme }) => theme.colors.darkGreen};
  border-radius: 0 0.65rem 0.65rem 0;
  justify-content: space-between;
  border-color: transparent;
  align-items: center;
  cursor: pointer;
  display: flex;

  transition: all 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.darkGreen};
  }

  p {
    line-height: 1.15;
  }
`;

/**
 * Container principal para a lista de vendedores.
 */
export const SallerActionContent = styled.div`
  justify-content: center;
  flex-direction: column;
  align-items: left;
  display: flex;

  span {
    line-height: 1.15;
  }
`;

/**
 * Estilo do preço exibido.
 */
export const SellerPrice = styled.span`
  font-family: ${({ theme }) => theme.fonts.primary};
  display: flex;
`;

export const SellerName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px;
  display: inline-block;
  color: ${({ theme }) => theme.colors.white};
`;
